import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { EmptyMessage, TablePanel } from "../style";

const formatDate = (ms) => {
  if (typeof ms !== "number") return "—";
  return new Date(ms).toLocaleString();
};

export default function ArticleTable({ text, data, onShowHistory }) {
  const rows = Array.isArray(data) ? data : [];

  return (
    <TablePanel>
      <Typography variant="h6">{text.table.byArticle}</Typography>
      {rows.length === 0 ? (
        <EmptyMessage>{text.charts.empty}</EmptyMessage>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{text.table.article}</TableCell>
                <TableCell>{text.filters.source}</TableCell>
                <TableCell align="right">{text.table.downloads}</TableCell>
                <TableCell>{text.table.lastDownload}</TableCell>
                <TableCell align="right">{text.table.actions}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} hover>
                  <TableCell>{r.title || "-"}</TableCell>
                  <TableCell>
                    {text.sources[r.source] || r.source || "-"}
                  </TableCell>
                  <TableCell align="right">{r.downloadCount ?? 0}</TableCell>
                  <TableCell>{formatDate(r.lastDownloadedAt)}</TableCell>
                  <TableCell align="right">
                    <Tooltip title={text.table.viewHistory} arrow placement="top">
                      <IconButton
                        size="small"
                        color="secondary"
                        onClick={() => onShowHistory(r)}
                      >
                        <HistoryRoundedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </TablePanel>
  );
}
